import { render } from "./TenantManage.vue?vue&type=template&id=3aed10d7&scoped=true"
import script from "./TenantManage.vue?vue&type=script&lang=js"
export * from "./TenantManage.vue?vue&type=script&lang=js"

import "./TenantManage.vue?vue&type=style&index=0&id=3aed10d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aed10d7"]])

export default __exports__